import { BaseFieldConfig, ComponentNameEnum } from '@/types';

const getColorFieldConfig = (defaultValue = '#ffffff', showAlpha = false, showGradient = false, allowTransparent = false, transparentValue = 'transparent'): BaseFieldConfig => ({
  componentName: ComponentNameEnum.COLOR,
  options: {
    defaultValue,
    showAlpha,
    showGradient,
    allowTransparent,
    transparentValue,
  },
});
export default getColorFieldConfig;
